export const APP_URL = import.meta.env.VITE_APP_URL;
export const GITHUB_URL = 'https://github.com/geoza2000/sharethelist';
